import {useForm, Controller} from 'react-hook-form'
import {useState, useEffect} from 'react'
import PropTypes from 'prop-types'

import {ModalHeader} from '../../../../../shared_components/core/modals/ModalHeaders'
import Button from '../../../../../shared_components/mui_base_components/button/Button'
import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'
import TextInput from '../../../../../shared_components/forms/v3/TextInput'

import './addDeputyStepThree.scss'

const AddDeputyStepThree = ({
  context,
  deputy,
  goBack,
  logMixpanelEvent,
  submit,
  updateDeputy
}) => {
  const [processing, setProcessing] = useState(false)

  const {control, handleSubmit} = useForm({
    defaultValues: {
      inviteText: deputy.inviteText || ''
    }
  })

  useEffect(() => {
    logMixpanelEvent('add_deputy_personal_message')
  }, [])

  const buttonText = context === 'pro_client_dashboard' ?
    'Save invitation' :
    'Send invitation'

  const headingText = context !== 'pro_client_dashboard' ?
    `One last step before we send ${deputy['first-name']} an invitation` :
    'Add a personal message'

  const handleInviteSubmit = () => {
    setProcessing(true)
    submit()
  }

  return (
    <div className='add-deputy-step-three'>
      <div className='add-deputy-message'>
        <ModalHeader
          heading={headingText}
          banner='Personal message'
          subheading="Let your Deputy know exactly why you're sharing your
          Everplan with them in your own words."
        />
        <form>
          <Controller
            name='inviteText'
            control={control}
            render={({field}) => (
              <TextInput
                {...field}
                label='Add a personal message (recommended)'
                multiline
                rows={10}
                onChange={value => {
                  field.onChange(value)
                  updateDeputy({inviteText: value.target.value})
                }}
              />
            )}
          />
        </form>
      </div>
      <ButtonGroup>
        <Button color='cancel' disabled={processing} onClick={goBack}>
          Back
        </Button>
        <Button
          loading={processing}
          onClick={handleSubmit(handleInviteSubmit)}>
          {buttonText}
        </Button>
      </ButtonGroup>
    </div>
  )
}

AddDeputyStepThree.propTypes = {
  context: PropTypes.string,
  deputy: PropTypes.object,
  goBack: PropTypes.func,
  logMixpanelEvent: PropTypes.func,
  submit: PropTypes.func,
  updateDeputy: PropTypes.func
}

export default AddDeputyStepThree
